module.exports = __webpack_public_path__ + "d8d36b3104a411ac446b7a879d8e8528.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/etho_capital.png
// module id = 1658
// module chunks = 0